import React from 'react';
import css from './authorized-layout.scss';
import { observer } from 'mobx-react';
import Header from './header';
import Avatar from '../../components/avatar/avatar';
import Navbar from '../../components/navbar/navbar';
import Frame from '../../components/frames/frame';

const Separator = () => {
    return (
        <div className={css.profile__body__separator}></div>
    )
}

const AuthorizedLayout = observer((props) => {
    return (
        <div className={css.root}>
            <Header />
            <div className={css.canvas}>
                <div className={css.container}>
                    <div className={css.page}>
                        <aside className={css.aside}>
                            <Frame blue left>
                                <div className={css.profile}>
                                    <div className={css.profile__header}>
                                        <span>Профиль</span>
                                    </div>
                                    <div className={css.profile__body}>
                                        <Avatar />
                                        <div className={css.profile__body__name}>
                                            Ольга Збыковская
                                        </div>
                                        <Separator />
                                        <Navbar />
                                    </div>
                                </div>
                            </Frame>
                        </aside>
                        <div className={css.workarea}>
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
});

export default AuthorizedLayout;